import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SpreadsheetLanding from "../pages/spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/yoybuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/taobao-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "/weidian-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "/1688-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "/yoybuy-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "/pandabuy-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "/sugargoo-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "/mulebuy-spreadsheet",
    element: <SpreadsheetLanding />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;